'use client';

import { useEffect, useRef } from 'react';

const HOVER_SELECTOR = 'a, button, [data-cursor], .service-card, .work-card, input, textarea, select';

export default function CustomCursor() {
  const ref = useRef<HTMLDivElement>(null);
  const mouse = useRef({ x: -100, y: -100 });
  const rendered = useRef({ x: -100, y: -100 });
  const raf = useRef(0);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.matchMedia('(pointer: coarse)').matches) return;

    const cursor = ref.current;
    if (!cursor) return;
    cursor.style.display = 'block';

    const onMove = (e: MouseEvent) => { mouse.current = { x: e.clientX, y: e.clientY }; };
    const loop = () => {
      rendered.current.x += (mouse.current.x - rendered.current.x) * 0.15;
      rendered.current.y += (mouse.current.y - rendered.current.y) * 0.15;
      cursor.style.transform = `translate3d(${rendered.current.x}px,${rendered.current.y}px,0)`;
      raf.current = requestAnimationFrame(loop);
    };

    const addHover = () => cursor.classList.add('is-hover');
    const rmHover = () => cursor.classList.remove('is-hover');
    const addPress = () => cursor.classList.add('is-press');
    const rmPress = () => cursor.classList.remove('is-press');

    // Bind hover via delegation (handles dynamic elements)
    const onOver = (e: MouseEvent) => {
      if ((e.target as HTMLElement)?.closest?.(HOVER_SELECTOR)) addHover();
    };
    const onOut = (e: MouseEvent) => {
      if ((e.target as HTMLElement)?.closest?.(HOVER_SELECTOR)) rmHover();
    };

    window.addEventListener('mousemove', onMove);
    document.addEventListener('mouseover', onOver);
    document.addEventListener('mouseout', onOut);
    document.addEventListener('mousedown', addPress);
    document.addEventListener('mouseup', rmPress);
    raf.current = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf.current);
      window.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseover', onOver);
      document.removeEventListener('mouseout', onOut);
      document.removeEventListener('mousedown', addPress);
      document.removeEventListener('mouseup', rmPress);
    };
  }, []);

  return (
    <div data-component-id="src/components/effects/CustomCursor.tsx:60:4" data-component-path="src/components/effects/CustomCursor.tsx" data-component-line="60" data-component-end-line="62" data-component-file="CustomCursor.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22custom-cursor%20hidden%22%7D" ref={ref} className="custom-cursor hidden" aria-hidden>
      <div data-component-id="src/components/effects/CustomCursor.tsx:61:6" data-component-path="src/components/effects/CustomCursor.tsx" data-component-line="61" data-component-end-line="61" data-component-file="CustomCursor.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22custom-cursor__dot%22%7D" className="custom-cursor__dot" />
    </div>
  );
}
